import PropTypes from 'prop-types'
import { Button } from '../Button/Button'
import { TextField } from '../TextField/TextField'
import { Pill } from '../Pill/Pill'
import styles from './HeaderTable.module.css'

const DEVICES = ['default', 'mobile']

const SearchIcon = () => (
  <span
    className="material-icons-outlined"
    style={{ fontSize: 16, lineHeight: 1, display: 'flex' }}
  >
    search
  </span>
)
const CloseIcon = () => (
  <span className="material-icons-outlined" style={{ fontSize: 16, lineHeight: 1, display: 'flex' }}>
    close
  </span>
)
const FilterListIcon = () => (
  <span className="material-icons-outlined" style={{ fontSize: 20, lineHeight: 1, display: 'flex' }}>
    filter_list
  </span>
)
const ViewWeekIcon = () => (
  <span className="material-icons-outlined" style={{ fontSize: 20, lineHeight: 1, display: 'flex' }}>
    view_week
  </span>
)

export function HeaderTable({
  device = 'default',
  tabs,
  filters,
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Buscar',
  onFiltersClick,
  onColumnsClick,
  secondaryAction,
  primaryAction,
  pills,
  resultsCount,
  className = '',
}) {
  const isMobile = device === 'mobile'
  const hasActions = Boolean(secondaryAction || primaryAction)
  const hasPillsResults = Boolean((pills && pills.length > 0) || resultsCount !== undefined)

  const searchField = (
    <div className={isMobile ? styles['search--mobile'] : styles['search--default']}>
      <TextField
        size="sm"
        value={searchValue}
        onChange={onSearchChange}
        placeholder={searchPlaceholder}
        suffix={<SearchIcon />}
      />
    </div>
  )

  const adminFilters = onFiltersClick && (
    <div className={styles.adminFilters}>
      <Button variant="tertiary" icon size="sm" onClick={onFiltersClick} aria-label="Filtros">
        <FilterListIcon />
      </Button>
      {onColumnsClick && (
        <Button variant="tertiary" icon size="sm" onClick={onColumnsClick} aria-label="Columnas">
          <ViewWeekIcon />
        </Button>
      )}
    </div>
  )

  const actionSlot = (node) =>
    isMobile ? <div className={styles['actionSlot--mobile']}>{node}</div> : node

  return (
    <div className={[styles.headerTable, className].filter(Boolean).join(' ')}>
      <div className={styles.container}>
        {tabs && <div className={styles.tabsWrap}>{tabs}</div>}
        <div className={styles.body}>
          <div
            className={[styles.content, isMobile ? styles['content--mobile'] : styles['content--default']].join(
              ' '
            )}
          >
            {!isMobile && (
              <div className={styles.filtersSearch}>
                {filters &&
                  filters.map((filter, i) => (
                    <div key={i} className={styles.filterSlot}>
                      {filter}
                    </div>
                  ))}
                {searchField}
              </div>
            )}
            {!isMobile && adminFilters}
            {!isMobile && hasActions && (
              <div className={styles.actions}>
                {secondaryAction}
                {primaryAction}
              </div>
            )}
            {isMobile && hasActions && (
              <div className={[styles.actions, styles['actions--mobile']].join(' ')}>
                {secondaryAction && actionSlot(secondaryAction)}
                {primaryAction && actionSlot(primaryAction)}
              </div>
            )}
            {isMobile && (
              <div className={styles.filtersSearch}>
                {searchField}
                {adminFilters}
              </div>
            )}
          </div>
          {hasPillsResults && (
            <div
              className={[
                styles.pillsResults,
                isMobile ? styles['pillsResults--mobile'] : styles['pillsResults--default'],
              ].join(' ')}
            >
              {pills && pills.length > 0 && (
                <div className={[styles.pills, isMobile ? styles['pills--mobile'] : styles['pills--default']].join(' ')}>
                  {pills.map((pill, i) => (
                    <Pill key={i} iconRight={<CloseIcon />} onClick={pill.onRemove}>
                      {pill.label}
                    </Pill>
                  ))}
                </div>
              )}
              {resultsCount !== undefined && (
                <div className={styles.results}>
                  <span className={styles.resultsLabel}>Mostrando</span>
                  <span className={styles.resultsCount}>{resultsCount} resultados</span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

HeaderTable.propTypes = {
  device: PropTypes.oneOf(DEVICES),
  tabs: PropTypes.node,
  filters: PropTypes.arrayOf(PropTypes.node),
  searchValue: PropTypes.string,
  onSearchChange: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  onFiltersClick: PropTypes.func,
  onColumnsClick: PropTypes.func,
  secondaryAction: PropTypes.node,
  primaryAction: PropTypes.node,
  pills: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      onRemove: PropTypes.func,
    })
  ),
  resultsCount: PropTypes.number,
  className: PropTypes.string,
}
